import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { useAuth } from '../../contexts/AuthContext';

const formatApiError = (detail) => {
  if (detail == null) return 'Something went wrong.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return String(detail);
};

const AccountProfile = () => {
  const { user, updateProfile } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || '',
    phone: user?.phone || ''
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateProfile(form);
      toast.success('Profile updated');
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || 'Update failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="account-profile">
      <h2 className="font-['Oswald'] text-2xl text-[#F2EDE6] tracking-wider mb-6">PROFILE</h2>
      <form onSubmit={handleSubmit} className="space-y-5 max-w-md">
        <div>
          <label className="block text-[#A19D98] text-sm mb-2">Email</label>
          <Input
            type="email"
            value={user?.email || ''}
            disabled
            className="bg-[#0A0A0A] border-[#2A2A2A] text-[#A19D98]"
          />
        </div>
        <div>
          <label className="block text-[#A19D98] text-sm mb-2">Full Name</label>
          <Input
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="profile-name-input"
            className="bg-[#0A0A0A] border-[#2A2A2A] text-[#F2EDE6]"
          />
        </div>
        <div>
          <label className="block text-[#A19D98] text-sm mb-2">Phone</label>
          <Input
            type="tel"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            data-testid="profile-phone-input"
            className="bg-[#0A0A0A] border-[#2A2A2A] text-[#F2EDE6]"
          />
        </div>
        <button
          type="submit"
          disabled={saving}
          data-testid="profile-save-btn"
          className="btn-primary flex items-center gap-2 disabled:opacity-50"
        >
          {saving ? <Loader2 size={16} className="animate-spin" /> : 'Save Changes'}
        </button>
      </form>
    </div>
  );
};

export default AccountProfile;
